import { Box, Chip, Container, Grid, Stack, Tab, Tabs, Typography } from '@mui/material';
import { AppWidgetSummary } from '@src/sections/@dashboard/app';
import numeral from 'numeral';
import { useSubscriptionContext } from './provider';
import { useSubscriptionService } from './hooks';
import Iconify from '@src/components/iconify';
import SvgColor from '@src/components/svg-color';
import palette from '@src/theme/palette';

const PLAN_TABS = [
  { label: 'All Plans', value: '' },
  { label: 'Weekly VIP', value: 'WEEKLY' },
  { label: 'Monthly VIP', value: 'MONTHLY' },
];

const Header = () => {
  const { state, handleTabChange } = useSubscriptionContext();
  const { stats, counts } = useSubscriptionService();

  const weeklyCount = counts?.subscriptions?.find((s: any) => s.id === 'gwz_sub_1_1w')?.purchaseCount ?? 0;
  const monthlyCount = counts?.subscriptions?.find((s: any) => s.id === 'gwz_sub_2_1m')?.purchaseCount ?? 0;

  const tabCounts: Record<string, number> = {
    '': counts?.totalPurchaseCount ?? 0,
    'WEEKLY': weeklyCount,
    'MONTHLY': monthlyCount,
  };

  return (
    <Container>
      {/* Tab headers + access badge */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={3}
        flexWrap="wrap"
        gap={1}
      >
        <Tabs
          value={state.planType}
          onChange={(_, v) => handleTabChange(v)}
          TabIndicatorProps={{ style: { display: 'none' } }}
          sx={{ minHeight: 40 }}
        >
          {PLAN_TABS.map((tab) => {
            const isActive = state.planType === tab.value;
            return (
              <Tab
                key={tab.value}
                value={tab.value}
                disableRipple
                label={
                  <Stack direction="row" alignItems="center" gap={1}>
                    <Typography
                      fontSize={14}
                      fontWeight={isActive ? 700 : 500}
                      color={isActive ? 'white' : '#6B7280'}
                    >
                      {tab.label}
                    </Typography>
                    <Chip
                      label={tabCounts[tab.value]}
                      size="small"
                      sx={{
                        height: 22,
                        fontSize: 12,
                        fontWeight: 700,
                        bgcolor: isActive ? 'rgba(255,255,255,0.25)' : '#F3F4F6',
                        color: isActive ? 'white' : '#6B7280',
                        borderRadius: '6px',
                      }}
                    />
                  </Stack>
                }
                sx={{
                  minHeight: 40,
                  px: 2,
                  py: 0.75,
                  borderRadius: '8px',
                  bgcolor: isActive ? '#6A00AC' : 'transparent',
                  mr: 0.5,
                  textTransform: 'none',
                  '&.Mui-selected': { color: 'white' },
                }}
              />
            );
          })}
        </Tabs>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
            border: '1px solid #E5E7EF',
            borderRadius: '8px',
            px: 1.5,
            py: 0.75,
            bgcolor: '#FAFAFA',
          }}
        >
          <Iconify icon="mdi:lock-outline" width={16} sx={{ color: '#6B7280' }} />
          <Typography fontSize={12} color="#6B7280" fontWeight={500}>
            Access: Owner &amp; Developer only
          </Typography>
        </Box>
      </Stack>

      {/* Stat cards */}
      <Grid
        container
        spacing={{ xl: 3, lg: 3, md: 3, sm: 1.5, xs: 1.5 }}
        mb={2}
      >
        <Grid item xs={12} sm={6} md={6}>
          <AppWidgetSummary
            disabled
            title="Total Subscriptions (This Month)"
            value={numeral(stats?.count ?? 0).format('0,000')}
            color={"#16DBCC"}
						icon={<SvgColor src={`/assets/icons/ic_store.svg`} 
							sx={{ width: {
								xl: 24,
								lg: 24,
								md: 24,
								sm: 18,
								xs: 18
							}, height: {
								xl: 24,
								lg: 24,
								md: 24,
								sm: 18,
								xs: 18
							} }} />}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <AppWidgetSummary
            disabled
            title="The Total Revenue (This Month)"
            value={`€${numeral(stats?.totalAmount ?? 0).format('0,000')}`}
            color={palette.green.main}
						icon={"tabler:tax-euro"}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Header;
